

import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import axios from "axios";
import Reaptcha from "reaptcha";
import Helmet from "react-helmet";
import Zoom from "react-medium-image-zoom";
import QRCode from "react-qr-code";
import {Link} from "react-router-dom";
import * as url from "url";

function OfferPage(props) {

    const { t, i18n } = useTranslation()

    const [name, setName] = useState('');
    const [phoneOrEmail, setPhoneOrEmail] = useState('');
    const [phoneOrEmail2, setPhoneOrEmail2] = useState('');
    const [note, setNote] = useState('');


    const [verified, setVerified] = useState(false);
    const [recaptcha, setRecaptcha] = useState(false);

    const onVerify = () => {
        setVerified(true)
    };

    const [noteError, setNoteError] = useState(false);

    const sendToTelegram = (e) => {
        e.preventDefault();

        // step 1 - local direct to thank page

        if(name || phoneOrEmail || note){

            // step 2 - api
            try{

                axios.post('https://api.lukyanchuk.com/api/v3/public/send/telegram', {
                    name,
                    phone: phoneOrEmail,
                    email: phoneOrEmail2,
                    note,
                    "g-recaptcha-response": verified
                }).then(res => {
                    setRecaptcha(false);
                    console.log(res.data)

                    // TODO: save to local storage ip and hide form

                    window.location.href = '/thank-you';

                }).catch(e => console.log(e))

            }catch (e) {
                alert(e)
                console.log(e)
            }
        }else{
            _toggleErrorNote();
        }
    }

    const _toggleErrorNote = () => setNoteError(!noteError);

    const divStyle = {
        // Note: 'backgroundImage' uses camelCase in React inline styles
        backgroundImage: `url(https://images.unsplash.com/photo-1559981838-04ff9418dd12)`,
        backgroundSize: 'cover', // Scales the image to cover the entire div
        backgroundRepeat: 'no-repeat', // Prevents the image from repeating
        backgroundPosition: 'center', // Centers the image
        width: '100%', // Ensure the div has a defined size
        height: '100%', // Ensure the div has a defined size
    };

    return (<div className={'vh-100 d-flex flex-column justify-content-around align-items-center border'} style={divStyle}>

        <Helmet>
            <title>{t('nav.cooperation')} with Yaroslav Lukyanchuk</title>
            <meta name="description" content="Yaroslav Lukyanchuk" />
        </Helmet>

        <div className="container text-dark text-start pt-5" >

            <h1 className={'opacity-25 mb-5'} style={{fontSize: '5vw'}}>{t('nav.cooperation')}</h1>
            <br/>
           <div className="d-flex align-items-start justify-content-start">
               <div className="short-connect col-md-5 d-md-block d-none">
                   {/*<Zoom>*/}
                   {/*    <QRCode*/}
                   {/*        size={256}*/}
                   {/*        style={{ height: "200px", maxWidth: "100%", width: "200px" }}*/}
                   {/*        value={'mailto:yarik@lukyanchuk.com'}*/}
                   {/*        viewBox={`0 0 256 256`}*/}
                   {/*    />*/}
                   {/*</Zoom>*/}

                   <span className="display-1">
                       ✍
                       {/*💬*/}
                   </span>
                   <h3 className={'p-3'}>
                       Let me know what you are thinking of and i’ll get back to you shortly.
                   </h3>
                   <form onSubmit={sendToTelegram} className={''}>
                       <div className="d-flex flex-wrap align-items-center">
                           {
                               noteError && <div className={'col-md-12 d-flex justify-content-between mb-5'}>
                                   <h5 className={'text-danger w-100 border border-danger p-2'}>
                                       Fields empty!
                                   </h5>

                                   <button onClick={_toggleErrorNote} className={'nav-link p-2 text-secondary'}>
                                       close
                                   </button>
                               </div>
                           }
                           <div className="col-md-4 col-12 p-1">
                               <input type="text" id={'name'} value={name} onChange={(e) => setName(e.target.value)} placeholder={'Name'} className={'form-control border-0 border-bottom rounded-0'}/>
                           </div>
                           <div className="col-md-4 col-12 p-1">
                               <input type="text" id={'phoneOrEmail'} value={phoneOrEmail} onChange={(e) => setPhoneOrEmail(e.target.value)} placeholder={'+1 Phone number'} className={'form-control border-0 border-bottom rounded-0'}/>
                           </div>

                           <div className="col-md-4 col-12 p-1">
                               <input type="email" id={'phoneOrEmail2'} value={phoneOrEmail2} onChange={(e) => setPhoneOrEmail2(e.target.value)} placeholder={'@Email'} className={'form-control border-0 border-bottom rounded-0'}/>
                           </div>

                           <input type="text" id={'note'} value={note} onChange={(e) => setNote(e.target.value)} placeholder={'Something about idea or project'} className={'form-control border-0 border-bottom rounded-0 mt-3 col-md-12 m-1'}/>
                       </div>
                       <div className="d-flex flex-wrap justify-content-between align-items-end">
                           <button type={'submit'} className="btn btn-dark p-3 rounded-pill col-12 col-md-4 mt-5 m-1">
                               Submit
                           </button>
                           <Reaptcha
                               className={'m-auto m-md-0'}
                               // size="invisible"
                               ref={e => (setRecaptcha(e))}
                               // sitekey="6LcnW98UAAAAAKwKipkUQedRZmocs5SmqlMzslBZ"
                               sitekey="6LernYArAAAAAKzrVS4_bt2liBktchGKMW7wxbce"
                               onVerify={onVerify}
                               onExpire={true}
                           />
                       </div>
                   </form>

               </div>
               <div className="form bg-white p-2 opacity-75 d-md-none d-block">
                   {/*<h3 className={'p-3 pb-0'}>*/}
                   {/*    Let's work together on project*/}
                   {/*</h3>*/}
                   {/*<br/>*/}
                   <form onSubmit={sendToTelegram} className={''}>
                      <div className="d-flex flex-wrap align-items-center">
                          {
                              noteError && <div className={'col-md-12 d-flex justify-content-between mb-5'}>
                                  <h5 className={'text-danger w-100 border border-danger p-2'}>
                                      Fields empty!
                                  </h5>

                                  <button onClick={_toggleErrorNote} className={'nav-link p-2 text-secondary'}>
                                      close
                                  </button>
                              </div>
                          }
                          <div className="col-md-4 col-12 p-1">
                              <input type="text" id={'name'} value={name} onChange={(e) => setName(e.target.value)} placeholder={'Name'} className={'form-control border-0 border-bottom rounded-0'}/>
                          </div>
                          <div className="col-md-4 col-12 p-1">
                              <input type="text" id={'phoneOrEmail'} value={phoneOrEmail} onChange={(e) => setPhoneOrEmail(e.target.value)} placeholder={'+1 Phone number'} className={'form-control border-0 border-bottom rounded-0'}/>
                          </div>

                          <div className="col-md-4 col-12 p-1">
                              <input type="email" id={'phoneOrEmail2'} value={phoneOrEmail2} onChange={(e) => setPhoneOrEmail2(e.target.value)} placeholder={'@Email'} className={'form-control border-0 border-bottom rounded-0'}/>
                          </div>

                          <input type="text" id={'note'} value={note} onChange={(e) => setNote(e.target.value)} placeholder={'Something about idea or project'} className={'form-control border-0 border-bottom rounded-0 mt-3 col-md-12 m-1'}/>
                      </div>
                       <div className="d-flex flex-wrap justify-content-between align-items-end">
                           <button type={'submit'} className="btn btn-dark p-3 rounded-pill col-12 col-md-4 mt-5 m-1">
                               Submit
                           </button>
                           <Reaptcha
                               className={'m-auto m-md-0'}
                               // size="invisible"
                               ref={e => (setRecaptcha(e))}
                               // sitekey="6LcnW98UAAAAAKwKipkUQedRZmocs5SmqlMzslBZ"
                               sitekey="6LernYArAAAAAKzrVS4_bt2liBktchGKMW7wxbce"
                               onVerify={onVerify}
                               onExpire={true}
                           />
                       </div>
                   </form>
               </div>
           </div>


            <a href="/" className={'nav-link opacity-25 mt-5'}>
                <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                     xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M5 12h14M5 12l4-4m-4 4 4 4"/>
                </svg>
                Back
            </a>

        </div>


    </div>);
}

export default OfferPage;
